@import (reference) '../../../../constants/spacing.module.less';

.service-details {
  gap: @space-32;
  align-items: center;
}
